import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromNotificationTemplateActions from './notification-template.actions';
import { NotificationTemplate } from './notification-template.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: NotificationTemplate };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromNotificationTemplateActions.Actions): State {
    switch (action.type) {
        case fromNotificationTemplateActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromNotificationTemplateActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromNotificationTemplateActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/notification-template/notification-template.reducer.ts